import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';
import { share } from 'rxjs/operators';
import { LocaleService } from '../shared/services/locale.service';
import { ViewportService } from '../shared/services/viewport.service';

@Component({
	selector: 'app-device-detect',
	templateUrl: './device-detect.component.html',
	styleUrls: ['./device-detect.component.scss'],
})
export class DeviceDetectComponent implements OnInit {
	selectedVal: string;
	deviceInfo: DeviceInfo;
	title = 'device-detection-sample';
	data: any;
	// activeFragment = this.route.fragment.pipe(share());
	constructor(
		private deviceDetectorService: DeviceDetectorService,
		private router: Router,
		public route: ActivatedRoute,
		public locale: LocaleService,
		public viewport: ViewportService
	) {}
	ngOnInit(): void {
		(queries: Params) => {
			if (queries['selectedValue'] !== undefined) {
				this.selectedVal = queries['selectedValue'];
			}
		};

		// get current page

		// this.selectedVal ='allCategories';

		this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
		// console.log(this.deviceInfo.userAgent)
		var str = this.deviceInfo.userAgent;
		let str2 = str.slice(str.indexOf('('), str.indexOf('Apple'));
		let str3 = str2.split(';');
		this.data = str3[str3.length - 1].replace(/[()]/g, '');
		// console.log(this.activeFragment)
	}
	get isMobile(): boolean {
		return this.deviceDetectorService.isMobile();
	}

	get isTablet(): boolean {
		return this.deviceDetectorService.isTablet();
	}

	get isDesktop(): boolean {
		return this.deviceDetectorService.isDesktop();
	}

	public onValChange(val: string) {
		this.selectedVal = val;
	}
}
